import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'purchaseOrderStatus',
})
export class PurchaseOrderStatusPipe implements PipeTransform {

  constructor(
    private translateService : TranslateService
  ) {}

  transform( value : string ) {
    const statusMap = {
      O: this.translateService.instant('PURCHASE_ORDER_STATUS_TYPES.ON_ORDER'),
      R: this.translateService.instant('PURCHASE_ORDER_STATUS_TYPES.RECEIVED'),
      S: this.translateService.instant('PURCHASE_ORDER_STATUS_TYPES.SUGGESTED')
    };

    return statusMap[value] || this.translateService.instant('PURCHASE_ORDER_STATUS_TYPES.SUGGESTED');
  }
}